<!--suppress ALL -->
<template>
  <div class="recharge">
    <div class="mask" v-if="message == '2'"></div>
    <div class="textBox" v-if="message == '2'">
      <p class="close_modal" @click="clickT('1')">X</p>
      <h4
        @click="clickAmount"
        style="width: 100%; text-align: center; padding-bottom: 10px"
      >
        ——会员充值储值免责协议——
      </h4>
      <div class="modal_main">
        重要提示：请您在接受使用本服务前务必先审慎
        阅读、充分理解本协议的相应条款，特别是免除
        或限制责任的条款、法律适用及争议解决条款。
        限制、免责、法律适用及争议解决等关系您切身
        利益的重要条款可能会以黑体加粗的形式提示您
        重点注意。会员储值服务协议（以下简称：“本
        协议，'）是合作商户（下称：“商家”）与在该商家
        店铺内消费的客户（以下简称：“您，')，就您成
        为会员并开通储值功能相关事项所订立的有效协
        议。您通过网络页面勾选“同意”或以其他方式选
        择接受本协议，即表示您已经理解本协议内容并
        同意受本协议约束，包括但不限于本协议正文及
        已经发布的或将来可能发布的关于本服务的各类
        规则、规范、公告、说明或通知等，以及其他各
        项网站规则、制度等。所有前述规则为本协议不
        可分割的组成部分，与本协议正文具有同等的法
        律效力。除非您已阅读并同意本协议所有内容，
        否则您无权使用本协议项下的服务。如您同意购
        买或使用本协议下的服务，即表示您自愿接受本 协议的所有内容。
        <br />第一条会员储值服务是商家在自己的店铺内发行
        并售卖的仅限于在发卡主体所属门店使用的电子
        虚拟卡服务，该会员储值卡内余额可抵现金使
        用，持卡消费者每次消费时仅支付实际消费的部 分，剩余款项可下次继续使用。
        <br />第二条您在购买商家储值卡或参与商家的优惠充
        值活动前，应仔细阅读该商家储值卡的充值及充
        值使用规则，包括但不限于适用门店范围、有效
        期、使用规则、退卡规则等，用户在购买或充值
        后，即视为您已经知悉并同意商家储值卡的使用 规则等。
        <br />第三条如商家对储值卡的适用门店有调整的，以
        商家实际支持的门店为准。
        <br />第四条如您在一张商家储值卡中充值了多笔款项
        的，在使用时，商家将会根据商家储值卡内充值
        款项的充值时间、充值款项有效期等信息决定每 笔充值款项的扣款顺序。
        <br />第五条如您进行储值卡充值时参与了商家的赠送
        活动的，在使用时，商家将根据商家的活动规则
        决定您的充值金额与赠送金额的扣款顺序。您在
        参与该充赠活动前，应向商家充分了解相应的活
        动规则，一旦您充值成功即视为您已经知悉并同 意相应的使用规则等。
        <br />第六条当您使用商家储值卡消费后，如发生退货／
        退款的，您使用储值卡支付的金额将被退回该储 值账户内。
        <br />第七条商家储值卡的退卡规则、退卡手续费等以
        商家储值卡说明页面为准。
        <br />第八条商家储值卡的具体有效期以商家储值卡说
        明页面为准。储值卡有效期届满后，您可向商家
        提出退款或延长有效期的申请；商家应根据您的 申请为您办理退款或延期。
        <br />第九条您理解并同意，如商家为您办理退款或延
        期的，商家有可能因该退款或延期行为向您收取
        延期手续费，具体手续费以储值卡说明页面或您 与商家协商的结果为准。
        <br />第十条商家开展其他优惠活动时，对于享受优惠
        的订单可能无法使用商家储值卡进行支付，具体 以商家的优惠活动规则为准。
        <br />第十一条您理解您办理优惠储值业务是您和商家
        之间达成的合约，您购买商家储值卡后，该笔资
        金将直接进入到该发卡商家的资金账户，如后期
        发生退款、商家关闭门店或其他事由导致您无法
        正常消费问题，由发卡商家承担责任，您应联系 发卡商家自行解决。
        <br />第十二条您确认并已知悉，商家发行储值卡，储
        值卡的使用和核销，及您使用商家储值卡过程中
        产生的体验感受、服务品质等，均由商家负责；
        平台展示和系统服务方，不负有任何明示或默示
        的担保责任。如您与商家因商家储值卡的使用而
        发生任何争议，包括但不限于商家提供的商品或
        服务的质量、价格、有效期、退货退款、退卡、
        售后服务、服务态度、储值卡无法使用等问题发
        生争议的，您应与商家采取协商或其他方式予以
        解决，收钱吧仅做展示服务，不负有任何的赔付 义务。
        <br />第十三条您同意并认可，商家有权不定期更换商
        家储值卡服务规则，并以在本平台网站或其他合
        理方式予以公布，无需另行单独通知您。该等变
        更自公告载明的生效时间开始生效，并成为本协
        议的一部分，与本协议具有同等的法律效力。
        <br />第十四条因本协议引发的或是与本协议有关的一
        切争议，您应联系商家协商解决。协商解决不成
        的，任何一方可向上海市普陀区有管辖权的法院 提起诉讼。
        <br />第十五条本协议一经您线上确认与同意，即发生
        法律效力，商家与您将共同受生效后的协议约 束。
      </div>
    </div>
    <div class="bg_color">
      <div class="leave_money">
        <div @click="opencards" v-if="this.showModal">打开卡包1</div>
        <p>我的余额</p>
        <p @click="clickT('2')">《储值免责协议》</p>
      </div>
      <div class="balance">
        <span>{{ this.moneys }} </span><span style="font-size: 10px">元</span>
      </div>
      <!-- button -->
      <div class="link_btn">
        <router-link to="/Detail" class="link_save">充值记录</router-link>
        <router-link to="/PaymentCode" class="link_pay">会员支付</router-link>
      </div>
    </div>
    <div class="content">
      <div style="display: flex; justify-content: space-between">
        <p class="recharge_num">充值金额</p>
        <p class="recharge_num_right">{{ storeName }}</p>
      </div>
      <div
        v-if="this.showModal"
        :class="money == 0.01 ? 'actives' : 'check_item'"
        @click="setCheckMoney(0.01, 0)"
      >
        <p class="recharge_money">{{ 0.01 }}元</p>
      </div>
      <div class="footer">
        <div
          v-for="(item, index) in this.checkList"
          :class="Number(item.payamt) == money ? 'actives' : 'check_item'"
          :key="index"
          @click="setCheckMoney(Number(item.payamt), Number(item.zsamt))"
        >
          <p class="recharge_money">{{ item.payamt }}元</p>
          <p class="saves_num" v-if="item.zsamt && Number(item.zsamt) != 0">
            赠送卡值:{{ item.zsamt }}
          </p>
        </div>
        <!-- <p class="remarks">添加充值备注</p> -->
        <div class="moneydetail" @click="handlePay">
          到账金额{{ zsmoney }}元
        </div>
        <div class="payBtn" @click="handlePay">充值{{ money }}元</div>
        <!-- <div class="payBtn" @click="returnMp" v-if="isWechatMP">返回小程序</div> -->
      </div>
    </div>
    <loading v-if="load"></loading>
  </div>
</template>
<script>
import wx from 'weixin-jsapi'
import { Toast } from 'mint-ui'
import _ from 'lodash'

// 收钱吧间连商户
// 银联商户
const companiesUseWapPay = [
  '66b43a8150ec2115bfa8a80b',
  '65dc54008120edcbe745ef1f',
  '66416e655787e6a5ff567181',
  '633268ce46b31f7b921189f9', // 百易购哈尔滨
  '6358e261cfc29677624950fa', // 食里飘香
  '64b0f65433447b50eb949b02', // 全盈
  '6711cb56272129ddcd60d52a', // 东九木
  '63ed8d7d3daa477e71717097', // 百易购大庆
  '6758033d6907446c9eba1186', // 熟食大王
  '676e907a6907447007ba1198', // 点亮青春麻辣烫
  '6553181deb217c3e2be64a21', // 尔品
  '6410384fc7a89d485a15f169', // VC鲜果
  '661797987c60b3370aa2209c', // 好果农77
  '66275a47fe2a82cbc1b91869', // 好果农55
  '66cd7beab6a7a04df28a7f30', // 3号生鲜
  '61ca6ef251aeb2275ba7b084', // 鸿昌达
  '62148e803c0a4c44b505a0fb', // 众汇生鲜沈阳
  '68e7498e48786d49a050532e', // 鲜生缘
  '68fb2fc948786d543350534c', // 永盛生鲜
  '693fb576729e763578378e63', // 百特佰群力店
  '6959fd76156b967a3f55f961', // 来来斑马
  "60aa4076d35c97da155b85f9", // 得吉信息
  '6a0137166e39384943ae533b', // 喜妮
  '6aa8ea8d16ca70cf83f1d82d', // 百特佰烘焙
  '6adead4b16ca708d36f1d832', // 惠迎禾
]

// 使用三方支付的商户
const companiesUseOtherPayments = {
  //  葫芦支付 NOTE 开通葫芦需要调用接口设置 app 版定和路径版定
  hulupos: [
    '63608fb8cfc2964b2449511b',
    '6423f04fa514f2dadaa5395f', // 农垦六处
    '6486bd0e0ed7eaa37f402030', // 东城生鲜
    '621491db3c0a4c1e3305a10d', // 大家购
  ],
  // 小精灵
  liantuobank: [
    '647e8e7e33447b11a0949ad8',
    '67da9cd57e03aa4816ede0b3',
    '68009d017e03aa4fc6ede0cd', // 果真盘锦
    '686764787df1084d73c0d853', // 果真甄选铁岭
    '686c8db0d63c577df08b136b', // 果真甄选开源
  ],
  // NOTE 间连商户要在上面的wap列表注册
  shouqianba: [
    '633268ce46b31f7b921189f9', // 百易购哈尔滨
    '62148e803c0a4c44b505a0fb', // 众汇生鲜沈阳
    '61ca6ef251aeb2275ba7b084', // 鸿昌达
    '6553181deb217c3e2be64a21', // 尔品
    '6358e261cfc29677624950fa', // 食里飘香
    '66b43a8150ec2115bfa8a80b', // 和味熟食 间连
    '6583feff409bb880dc0df59b', // 盈客隆 直连
    '65dc54008120edcbe745ef1f', // 映华源 间连
    '66416e655787e6a5ff567181', // 营口大家购 间连
    '63ed8d7d3daa477e71717097', // 百易购大庆
    '6711cb56272129ddcd60d52a', // 东九木
    '6758033d6907446c9eba1186', // 熟食大王
    '676e907a6907447007ba1198', // 点亮青春麻辣烫
    '6410384fc7a89d485a15f169', // VC鲜果
    '661797987c60b3370aa2209c', // 好果农77
    '66275a47fe2a82cbc1b91869', // 好果农55
    '66cd7beab6a7a04df28a7f30', // 3号生鲜
    '68e7498e48786d49a050532e', // 鲜生缘
    '68fb2fc948786d543350534c', // 永盛生鲜
    '6959fd76156b967a3f55f961', // 来来斑马
    '693fb576729e763578378e63', // 百特佰群力店
    "60aa4076d35c97da155b85f9", // 得吉信息
    '6a0137166e39384943ae533b', // 喜妮
    '6aa8ea8d16ca70cf83f1d82d', // 百特佰烘焙
    '6adead4b16ca708d36f1d832', // 惠迎禾
  ],
  chinaums: [
    '64b0f65433447b50eb949b02', // 全盈
  ],
}

export default {
  name: 'Recharge',
  data() {
    return {
      moneys: Number(localStorage.getItem('Money')).toFixed(2),
      appID: '',
      checkList: [
        // {payamt: "100.00"},
        // {payamt: "200.00"},
        // {payamt: "300.00"},
        // {payamt: "500.00"},
      ],
      money: 0,
      message: 1,
      zsmoney: 0,
      load: false,
      clickTimes: [],
      showModal: false,
      storeName: '',
      msg: '等待结果中',
      isWechatMP: false,
    }
  },
  mounted() {
    this.isWechatMP = typeof wx !== 'undefined' && wx.miniProgram.navigateBack()
    // 获取余额
    const companyID = localStorage.getItem('companyID')
    this.appcode = localStorage.getItem('appcode')
    this.storeName = localStorage.getItem('storeName')
    this.code = localStorage.getItem('code')
    let url = window.location.href.split('#')[0]
    url = encodeURIComponent(url)
    this.RequestVIP(
      `h5/vip/info?openID=${this.code}&CompanyID=${companyID}`,
      (res) => {
        this.moneyNum = Number(res.data.data.table1[0].Money).toFixed(2)
      },
      (err) => console.log(err)
    )
    //  获取充值金额
    this.RequestVIP(
      'h5/vip/recharge/list',
      (res) => {
        // res.data.data.table1 = [];
        if (!!res.data.data.table1 && !!res.data.data.table1.length > 0) {
          this.checkList = res.data.data.table1.sort(function (a, b) {
            let value1 = Number(a['payamt'])
            let value2 = Number(b['payamt'])
            return value1 - value2
          })
        }

        // console.log(res, data, "listtttttt");
      },
      (err) => console.log(err)
    )
    console.log(this.is3rdPayment(), 'is3rdPayment')
    // 微信验证
    this.Request(
      'api/v1/wechat/jsapi/signature',
      {
        url,
        // 判断是否是用三方支付，根据结果选择不同的terminalID做签名
        terminalID: this.is3rdPayment()
          ? this.getSignClient()
          : this.getPayClient(),
      }, //
      (r) => {
        if (r.data.code === '20000') {
          const { data } = r
          wx.config({
            debug: false, // 开启调试模式, 调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: data.data.appid, // 必填，公众号的唯一标识
            timestamp: data.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: data.data.nonceStr, // 必填，生成签名的随机串
            signature: data.data.signature, // 必填，签名
            jsApiList: ['chooseWXPay', 'openCard'], // 必填，需要使用的JS接口列表
          })
          this.appID = data.data.appid
        } else {
          alert(r.data.msg)
        }
      },
      (err) => {
        alert(err)
      }
    )
  },
  methods: {
    // returnMp() {
    //   if (this.isWechatMP) {
    //     // 小程序环境
    //     wx.miniProgram.navigateBack()
    //     // 如果需要返回特定页面：
    //     // wx.miniProgram.switchTab({ url: '/pages/index/index' });
    //   } else {
    //     // 普通浏览器环境
    //     window.history.back()
    //   }
    // },
    opencards() {
      wx.openCard({
        cardList: [
          {
            cardId: 'ppyGevjg2EVGrE-ex1s61aIrR_yE8',
            code: '469084167983',
          },
        ],
        success(res) {
          this.msg = JSON.stringify(res)
          // 处理成功的情况
        },
        fail(err) {
          this.msg = JSON.stringify(err)
          // 处理失败的情况
        },
      })
    },
    setCheckMoney(e, v) {
      let zs = v ? v : 0
      this.money = e
      this.zsmoney = e + zs
    },
    clickT(val) {
      this.message = val
    },
    clickAmount() {
      const now = Date.now()
      this.clickTimes.push(now)
      if (this.clickTimes.length === 6 && now - this.clickTimes[0] <= 2000) {
        this.showModal = true
        this.clickTimes = []
      } else {
        if (this.clickTimes.length > 6 || now - this.clickTimes[0] > 2000) {
          this.clickTimes.shift()
        }
      }
    },
    // 获取三方供应商名称
    getProviderName() {
      let name = ''
      _.each(companiesUseOtherPayments, (v, k) => {
        if (_.includes(v, localStorage.getItem('companyID'))) {
          name = k
        }
      })
      return name
    },
    // 根据需要用三方支付的的商户列表来判断是否用三方支付
    is3rdPayment() {
      let companyID = localStorage.getItem('companyID')
      return (
        _.includes(companiesUseOtherPayments.hulupos, companyID) ||
        _.includes(companiesUseOtherPayments.liantuobank, companyID) ||
        _.includes(companiesUseOtherPayments.shouqianba, companyID) ||
        _.includes(companiesUseOtherPayments.chinaums, companyID)
      )
    },
    useWapPay() {
      return _.includes(companiesUseWapPay, localStorage.getItem('companyID'))
    },
    // 用来调用config签名时用到的terminalID
    getSignClient() {
      return _.split(localStorage.getItem('payclient'), '|')[1]
    },
    // 用来调用支付事用到的terminalID
    getPayClient() {
      return _.split(localStorage.getItem('payclient'), '|')[0]
    },
    timestampFromRaw(raw, providerName) {
      // timestamp:
      if (providerName === 'hulupos') {
        return raw.timeStamp
      } else if (providerName === 'liantuobank') {
        return raw.timeStamp
      } else {
        return raw.timestamp
      }
    },

    handlePay() {
      if (this.money === 0) {
        Toast('请选择充值金额！')
        return
      }
      if (this.code === '' || !localStorage.getItem('VIPNO')) {
        Toast('页面数据有误，请尝试重新进入')
        return
      }

      this.load = true
      const mallPayload = {
        companyID: localStorage.getItem('companyID'),
        shopID: localStorage.getItem('shopID'),
        openID: this.code,
        amount: this.money,
        type: 2,
      }
      this.RequestMall(
        'POST',
        `h5/mall/order?shopID=${localStorage.getItem('shopID')}&openID=${
          this.code
        }`,
        mallPayload,
        (r) => {
          console.log('订单创建成功')
          const orderID = r.data.data.orderID
          // TODO 这里只有一些参数上的差异，可以优化掉不用if else
          let reqBody = {}
          // const storeID = localStorage.getItem('storeID') ? '|' + localStorage.getItem('storeID') : ''
          // const storeIDPure = localStorage.getItem('storeID') ? localStorage.getItem('storeID') : ''
          const payloadBodyField = localStorage.getItem('storeID')
            ? `${localStorage.getItem('appcode')}|${localStorage.getItem(
                'VIPNO'
              )}|${localStorage.getItem('storeID')}`
            : `${localStorage.getItem('appcode')}|${localStorage.getItem(
                'VIPNO'
              )}`
          // 不是用dejipay
          // try {
          if (this.is3rdPayment()) {
            console.log('三方支付')
            switch (this.getProviderName()) {
              case 'hulupos':
                console.log('葫芦')
                reqBody = {
                  providerName: 'hulupos',
                  payType: 'wechat',
                  clientType: 'mediapress',
                  terminalID: this.getPayClient(),
                  notifyURL:
                    'http://www.smartmis.com/vip2webservice/x5service.asmx/VIP_FINFULL',
                  // body: `${localStorage.getItem("appcode")}|${localStorage.getItem("VIPNO")}${storeID}`,
                  body: payloadBodyField,
                  totalAmount: this.money * 100,
                  outTradeNo: orderID,
                  subAppID: this.appID,
                  subOpenID: localStorage.getItem('code'),
                  companyID: localStorage.getItem('companyID'),
                }
                break
              case 'liantuobank':
                console.log('小精灵')
                console.log(this.getPayClient())
                console.log(this.money)
                console.log(orderID)
                try {
                  reqBody = {
                    providerName: 'liantuobank',
                    merchantCode: this.getPayClient(),
                    totalAmount: this.money * 1,
                    outTradeNo: orderID,
                    subAppId: this.appID,
                    // "notifyUrl": `http://www.smartmis.com/vip2webservice/x5service.asmx/VIP_FINFULL?appCode=${localStorage.getItem("appcode")}&vipNo=${localStorage.getItem("VIPNO")}&openId=${localStorage.getItem("code")}`,
                    notifyUrl: `http://www.smartmis.com/vip2webservice/x5service.asmx/VIP_FINFULL_Openid_V2?appCode=${localStorage.getItem(
                      'appcode'
                    )}&vipNo=${localStorage.getItem(
                      'VIPNO'
                    )}&openId=${localStorage.getItem('code')}`,
                    openId: localStorage.getItem('code'),
                  }
                  console.log('**********')
                  console.log(reqBody)
                } catch (e) {
                  console.log('*********************')
                  console.log(e)
                }
                break
              case 'shouqianba':
                reqBody = {
                  providerName: 'shouqianba',
                  payType: 'wechat',
                  // "terminalID": "657a5c5598fd979452de07c2",
                  terminalID: this.getPayClient(),
                  // "body": "iphone 12",
                  // body: `${localStorage.getItem("appcode")}|${localStorage.getItem("VIPNO")}${storeID}`,
                  body: payloadBodyField,
                  outOrderNo: orderID,
                  totalFee: `${this.money * 100}`,
                  openID: localStorage.getItem('code'),
                  notifyUrl: `http://www.smartmis.com/vip2webservice/x5service.asmx/VIP_FINFULL?appCode=${localStorage.getItem(
                    'appcode'
                  )}&vipNo=${localStorage.getItem(
                    'VIPNO'
                  )}&openId=${localStorage.getItem('code')}`,
                  // "openID": "obaiut_MP3_7Kh2_a_maTORRyQWQ"
                  // providerName: "liantuobank",
                  // merchantCode: this.getPayClient(),
                  // totalAmount: this.money * 1,
                  // "outTradeNo": orderID,
                  // "subAppId": this.appID,
                  // "notifyUrl": `http://www.smartmis.com/vip2webservice/x5service.asmx/VIP_FINFULL?appCode=${localStorage.getItem("appcode")}&vipNo=${localStorage.getItem("VIPNO")}&openId=${localStorage.getItem("code")}`,
                  // "openId": localStorage.getItem("code")
                }
                break
            }
            console.log(reqBody)
          } else {
            console.log('非三方支付')
            reqBody = {
              providerName: 'dejipay',
              payType: 'wechat',
              clientType: 'mediapress',
              terminalID: localStorage.getItem('payclient'),
              notifyURL:
                'http://www.smartmis.com/vip2webservice/x5service.asmx/VIP_FINFULL',
              // body: `${localStorage.getItem("appcode")} |${localStorage.getItem("VIPNO")}${storeID}`,
              body: payloadBodyField,
              total_fee: this.money * 100,
              out_trade_no: orderID,
              // total_fee: 1,
              openID: localStorage.getItem('code'),
            }
          }

          // } catch (e) {
          //  consle.log('解析支付参数失败')
          // }
          console.log('支付跳转中')
          // 这里新引入了wappay直接跳转页面
          if (this.is3rdPayment() && this.useWapPay()) {
            console.log('wap pay')
            let companyID = localStorage.getItem('companyID')
            let baseUrl = ``
            if (_.includes(companiesUseOtherPayments.shouqianba, companyID)) {
              baseUrl =
                'https://api.cnuri.cn/payment-pre-stage/v1/payment/shouqianba/wappay'
            } else if (
              _.includes(companiesUseOtherPayments.chinaums, companyID)
            ) {
              baseUrl =
                'https://api.cnuri.cn/payment-pre-stage/v1/payment/chinaums/wappay'
            }
            // window.location = `${baseUrl}?companyID=${localStorage.getItem("companyID")}&terminalID=${this.getPayClient()}&apiToken=890ec0a4944f0023bd46b9d7bff6f357&amount=${this.money * 100}&body=${localStorage.getItem("appcode")}|${localStorage.getItem("VIPNO")}${storeID}&openID=${this.code}`
            window.location = `${baseUrl}?companyID=${companyID}&terminalID=${this.getPayClient()}&apiToken=890ec0a4944f0023bd46b9d7bff6f357&amount=${
              this.money * 100
            }&body=${payloadBodyField}&openID=${this.code}`
            // window.location = `http://localhost:8888/v1/payment/shouqianba/wappay?terminalID=${this.getPayClient()}&apiToken=890ec0a4944f0023bd46b9d7bff6f357&amount=10`
            // window.location = 'https://qr.shouqianba.com/gateway?client_sn=&operator=661cbf9b98fd97945272c4c9&return_url=https%3A%2F%2Fapi.cnuri.cn%2Fpayment-pre-stage%2Fv1%2Fpayment%2Fshouqianba%2Fwappay%2Fcallback&sign=21EF7300FBD67B383AF19BB04DF82054&subject=%E7%94%B5%E5%AD%90%E4%BC%9A%E5%91%98%E5%85%85%E5%80%BC&terminal_sn=100003790036950840&total_amount=10'
            return
          }

          console.log('支付跳转')
          this.Request1(
            'v1/payment/prepay',
            reqBody,
            (r) => {
              console.log('#######################')
              console.log(r)
              this.load = false
              // console.log(r, "resssssssss");
              const { data } = r
              let that = this
              // 失败逻辑
              if (data.code !== 0)
                return alert(data.msg ? data.msg : '请求支付失败')
              const { data: orderInfo } = data
              // 成功逻辑
              let prepayResult
              if (
                reqBody.providerName !== 'liantuobank' &&
                reqBody.providerName !== 'shouqianba'
              ) {
                prepayResult = JSON.parse(
                  reqBody.providerName === 'hulupos'
                    ? orderInfo.payInfo
                    : orderInfo.raw
                )
              }
              // console.log(prepayResult, "prepayResultprepayResultprepayResult");
              let raw = {}
              if (reqBody.providerName === 'hulupos') {
                raw = prepayResult
              } else if (reqBody.providerName === 'liantuobank') {
                raw = orderInfo
              } else if (reqBody.providerName === 'shouqianba') {
                raw = orderInfo.biz_response.data.wap_pay_request
              } else {
                raw = prepayResult.data
              }

              const { providerName } = reqBody

              wx.ready(function () {
                const packageData = {
                  timestamp: _.includes(
                    ['hulupos', 'liantuobank', 'shouqianba'],
                    providerName
                  )
                    ? raw.timeStamp
                    : raw.timestamp,
                  nonceStr: raw.nonceStr,
                  package:
                    providerName === 'hulupos' || providerName === 'shouqianba'
                      ? raw.package
                      : providerName === 'liantuobank'
                      ? raw.payPackage
                      : `prepay_id=${raw.prepay_id}`,
                  signType: raw.signType,
                  paySign: raw.paySign,
                }
                const payData = {
                  ...packageData,
                  success: function (res) {
                    // that.load = false;
                    window.location.href = '/#/Recharge'
                  },
                  cancel: function (res) {
                    // that.load = false;
                    alert('已取消支付')
                  },
                  fail: function (res) {
                    // that.load = false;
                  },
                }
                // console.log(payData)

                if (providerName === 'shouqianba') {
                  // wx.chooseWXPay(payData);
                  const shouqianbaData = {
                    appId: raw.appId,
                    ...packageData,
                    timeStamp: packageData.timestamp,
                  }
                  console.log('***')
                  console.log(shouqianbaData)
                  WeixinJSBridge.invoke(
                    'getBrandWCPayRequest',
                    shouqianbaData,
                    function (res) {
                      if (res.err_msg == 'get_brand_wcpay_request:ok') {
                        window.location.href = '/#/Recharge'
                        // 使用以上方式判断前端返回,微信团队郑重提示：
                        //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                      }
                    }
                  )
                } else {
                  console.log('###############################')
                  console.log(payData)
                  wx.chooseWXPay(payData)
                }
              })
            },
            (err) => {
              console.log(err)
            }
          )

          // return console.log()
          // 充值
          // 如果是百易购则使用葫芦支付
        }
      )
    },
  },
}
</script>
<style scoped>
.recharge {
  font-size: 8px;
  width: 100%;
  height: 100%;
  overflow: scroll;
}

.bg_color {
  width: 100%;
  height: 135px;
  box-sizing: border-box;
  background: linear-gradient(310deg, #ff9c60 0%, #ff5a61 100%);
  opacity: 1;
  padding: 17px 14px 0;
}

.content {
  width: 92%;
  position: fixed;
  top: 130px;
  left: 4%;
  max-height: 310px;
  border-radius: 5px;
  background: #fff;
  margin-top: -20px;
  z-index: 99;
  padding: 11px;
  box-sizing: border-box;
  overflow: scroll;
  z-index: 0;
}

.leave_money {
  width: 100%;
  color: #ffffff;
  font-size: 10px;
  display: flex;
  justify-content: space-between;
}

.balance {
  font-size: 33px;
  color: #ffffff;
}

.link_btn {
  display: flex;
  justify-content: flex-start;
}

.link_pay {
  margin-left: 11px;
  width: 67px;
  height: 21px;
  border: 1px solid #ffffff;
  opacity: 1;
  border-radius: 30px;
  text-align: center;
  font-size: 10px;
  line-height: 21px;
  color: #ffffff;
  text-decoration: none;
  background: url('/static/image/bigtime.png') 5px 4.5px no-repeat;
  background-size: 10.5px;
  padding-left: 5px;
}

.link_save {
  width: 67px;
  height: 21px;
  border: 1px solid #ffffff;
  opacity: 1;
  border-radius: 30px;
  text-align: center;
  font-size: 10px;
  line-height: 21px;
  color: #ffffff;
  text-decoration: none;
  background: url('/static/image/bigmoney.png') 5px 3px no-repeat;
  background-size: 13px;
  padding-left: 5px;
}

.recharge_money {
  margin-top: 12px;
}

.footer {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  /* margin-top: 13px; */
}

.recharge_num {
  font-size: 11px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  line-height: 13px;
  color: #353535;
  min-width: 44px;
}

.recharge_num_right {
  font-size: 9px;
  font-family: Source Han Sans CN;
  line-height: 13px;
  color: #807c7c;
  max-width: 150px;
}

.check_item {
  width: 45%;
  height: 54px;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  opacity: 1;
  color: #212121;
  font-size: 11px;
  border-radius: 3px;
  text-align: center;
  line-height: 18px;
  margin-top: 14px;
}

.actives {
  width: 45%;
  height: 54px;
  font-size: 11px;
  background: #ffffff;
  color: #f2553d;
  border: 1px solid #ff9c60;
  border-radius: 3px;
  text-align: center;
  line-height: 18px;
  margin-top: 14px;
}

.saves_num {
  font-size: 8px;
}

.links {
  text-decoration-line: none;
}

.payBtn {
  width: 214px;
  height: 29px;
  background: linear-gradient(95deg, #ff5a61 0%, #ff9c60 100%);
  margin-top: 2px;
  border-radius: 3px;
  font-size: 11px;
  line-height: 29px;
  color: #ffffff;
  text-align: center;
}

.textBox {
  width: 200px;
  height: 300px;
  background: #fff;
  border-bottom: 0.5px solid #e0e0e0;
  border-top: 0.5px solid #e0e0e0;
  font-size: 9px;
  color: #212121;
  position: fixed;
  top: 10px;
  left: 25px;
  padding: 10px 0 20px;
  z-index: 9999;
  border-radius: 5px;
}

.modal_main {
  width: 90%;
  margin-left: 5%;
  height: 295px;
  overflow: scroll;
  text-indent: 5px;
  letter-spacing: 1px;
  line-height: 15px;
}

.mask {
  width: 100%;
  height: 100%;
  background: black;
  opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
}

.close_modal {
  background: #ffffff;
  position: fixed;
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 50px;
  font-size: 20px;
  left: 110px;
  top: 345px;
}

.moneydetail {
  width: 100%;
  text-align: center;
  padding: 10px 0;
  font-size: 10px;
  color: #212121;
}
</style>



// WEBPACK FOOTER //
// src/Recharge/index.vue